module.exports = __webpack_public_path__ + "img/CREDMAP LOGO 4.67eab81a.png";